import { useEffect, useRef } from "react";

import { useSearchParams } from "react-router-dom";

import { URLKeys } from "src/router/SearchParams";

type Callback = (runId: string) => void;

export const useLoadTestRunResultsListener = (
  callback: Callback,
  enabled: boolean = true,
) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const runId = searchParams.get(URLKeys.TestRunResultsId);

  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const loadedRunIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    if (!runId) {
      loadedRunIdRef.current = null;
      return;
    }
    if (loadedRunIdRef.current === runId) {
      return;
    }

    loadedRunIdRef.current = runId;
    callbackRef.current(runId);
    // Consumed: from here on the results are the graph's state. Leaving the
    // id behind would make following the same link a second time a no-op,
    // because the URL would already read the way the click leaves it.
    // Replaced rather than pushed, so Back does not re-run the load.
    setSearchParams(
      (params) => {
        params.delete(URLKeys.TestRunResultsId);
        return params;
      },
      { replace: true },
    );
  }, [runId, enabled, setSearchParams]);
};
